import React from 'react';
import Media from 'react-media';
import glamorous from 'glamorous';
import Button from '../../../../../common/components/Button';
import { RenderActive, WizardEngine } from '../../Wizard';
import HR from '../../HorizontalRule';
import ProgressIndicator from '../../ProgressIndicator';
import QuestionGroup from '../QuestionGroup';

const FlexRow = glamorous.div(
  ({ verticalMargin, horizontalMargin, margin, stacked }) => {
    return {
      display: 'flex',
      width: '100%',
      flexDirection: stacked ? 'column' : 'row',
      flexWrap: 'nowrap',
      '& > *': {
        '& + *': stacked
          ? { marginTop: verticalMargin || margin }
          : { marginLeft: horizontalMargin || margin },
      },
    };
  }
);

class SurveyWizard extends React.Component {
  render() {
    const {
      survey,
      responses,
      errors,
      saveQuestionValue,
      onQuestionBlur,
      color,
      submitSurvey,
      disableSubmit,
    } = this.props;

    const steps = survey.questionGroups.map(group => {
      return {
        ...group,
        id: group.key,
        component: 'QuestionGroup',
        color,
      };
    });

    return (
      <div>
        <glamorous.Div marginBottom="2rem">
          <h4 color={color}>{survey.name}</h4>
          <h6>{survey.description}</h6>
        </glamorous.Div>
        <WizardEngine steps={steps}>
          <ProgressIndicator
            showLabels={false}
            progressUnit="Question Group"
            style={{ marginBottom: '2rem' }}
          />
          <RenderActive
            stepComponents={{ QuestionGroup }}
            onChange={saveQuestionValue}
            onBlur={onQuestionBlur}
            responses={responses}
            errors={errors}
          />
          {({ goForward, goBack, activeIndex, steps }) => {
            const backgroundColor = steps[activeIndex].color;
            const buttonProps = {
              raised: true,
              primary: true,
              backgroundColor,
            };
            return (
              <Media query="(max-width: 425px)" key="customNav">
                {isPhone => {
                  return (
                    <div>
                      <FlexRow margin="2%" style={{ marginTop: '2rem' }}>
                        <Button
                          {...buttonProps}
                          icon="arrow_back"
                          label={isPhone ? undefined : 'back'}
                          style={{
                            transition: 'background-color 1s ease',
                            flexGrow: 1,
                            visibility: activeIndex > 0 ? 'visible' : 'hidden',
                          }}
                          onClick={goBack}
                        />
                        <Button
                          {...buttonProps}
                          icon="arrow_forward"
                          label={isPhone ? undefined : 'next'}
                          style={{
                            transition: 'background-color 1s ease',
                            flexGrow: 1,
                            visibility:
                              activeIndex < steps.length - 1
                                ? 'visible'
                                : 'hidden',
                          }}
                          onClick={goForward}
                        />
                      </FlexRow>
                      {activeIndex === steps.length - 1 && (
                        <div>
                          <HR color={backgroundColor} />
                          <Button
                            {...buttonProps}
                            label="Submit"
                            style={{
                              width: 'fit-content',
                            }}
                            onClick={submitSurvey}
                            disabled={disableSubmit}
                          />
                        </div>
                      )}
                    </div>
                  );
                }}
              </Media>
            );
          }}
        </WizardEngine>
      </div>
    );
  }
}

export default SurveyWizard;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/DetailPage/WizardLayout.js